import React, { useState } from "react";
import "./Pgmtextfield.scss";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../constants/dateFormat/formatDate";
import { NotificationManager } from "react-notifications";

const PgmTextField = ({ search, handleChange, SearchPgmList, searchInputRef, toDate, fromDate, handleFromDateChange, handleToDateChange,
  handleStatusDropdownChange, selectedRemarks, activeButton, pendingStatus, resetStatusFilter, selectedExecutiveId, areaExecutiveList, handleExecutiveChange }) => {
  const { t } = useTranslation();
  const today = formatDate(new Date());
  const [notificationShown, setNotificationShown] = useState(false);

  const isSearchDisabled = () => {
    return (
      !search &&
      (!fromDate || (fromDate && !toDate)) &&
      !selectedRemarks &&
      !selectedExecutiveId
    );
  };

  const handleFromDateSelection = (event) => {
    const newFromDate = event.target.value;
    handleFromDateChange(event);

    if (!newFromDate) {
      setNotificationShown(false);
      resetStatusFilter();
      return;
    }

    if (!toDate && !notificationShown) {
      NotificationManager.info(t('pgmlist.toDateMessage'));
      setNotificationShown(true);
    }
  };

  const handleToDateSelection = (event) => {
    const newToDate = event.target.value;
    handleToDateChange(event);

    if (!newToDate) {
      setNotificationShown(false);
      resetStatusFilter();
      return;
    }

    if (!fromDate && !notificationShown) {
      NotificationManager.info(t('pgmlist.fromDateMessage'));
      setNotificationShown(true);
    }
  };

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "") {
      resetStatusFilter();
    } else {
      handleStatusDropdownChange(event);
    }
  };

  return (
    <div>
      <div className="pgm_list_textfield_textfield_containers">
        <div className="pgmtextfield_dropdown">
          <div className="input-wrapper search-input-pgm">
            <label htmlFor="search">{t('common.searchLabel')}</label>
            <input className="search-placeholder" type="text" name="search" ref={searchInputRef} value={search} onChange={handleChange} placeholder={t('pgmlist.searchPlaceholder')} />
          </div>
          <div className="partner-date-search">
            <div className="input-wrapper">
              <label htmlFor="fromDate">{t('partorderlist.fromdate')}:</label>
              <input type="date" name="fromDate" value={fromDate} onChange={handleFromDateSelection} max={toDate ? toDate : today} />
            </div>
            <div className="input-wrapper">
              <label htmlFor="toDate">{t('partorderlist.todate')}:</label>
              <input type="date" name="toDate" value={toDate} onChange={handleToDateSelection} min={fromDate} max={today} />
            </div>
          </div>
          <div className="input-wrapper select-pgm-filter">
            <select
              onChange={handleExecutiveChange}
              value={selectedExecutiveId}
            >
              <option value="">
                {t('areaExecutive.selectAreaExecutive')}
              </option>
              {areaExecutiveList?.results?.map((executive) => (
                <option key={executive.id} value={executive.id}>
                  {executive.name}
                </option>
              ))}
            </select>
          </div>
          {activeButton === 'pending' && (
            <div className="input-wrapper select-pgm-filter">
              <select
                onChange={handleDropdownChange}
                value={selectedRemarks}
              >
                <option value="">
                  {t('pgmlist.selectstatus')}
                </option>
                {pendingStatus && Object.entries(pendingStatus).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <button className="button_search-pgmlist" onClick={SearchPgmList} disabled={isSearchDisabled()}> {t('common.searchButton')}</button>
      </div>
    </div>
  );
};

export default PgmTextField;
